export const LAYERS = {
  HOME_CONNECTION: 'HOME_CONNECTION',
  HEAT_SOURCE_CONNECTION: 'HEAT_SOURCE_CONNECTION',
  DISTRIBUTION_NETWORK: 'DISTRIBUTION_NETWORK',
  HOME_CONNECTION_POINT: 'HOME_CONNECTION_POINT',
  HEAT_SOURCE_POINT: 'HEAT_SOURCE_POINT',
};
